import { DateTime } from "luxon";

/** Zeitzone, in der alle Fristen des Bewerbungsverfahrens definiert sind. */
export const applicationTimeZone = "Europe/Berlin";

/**
 * Wahr, wenn die Uhr des Bewerbers zu diesem Zeitpunkt anders geht als in
 * Deutschland.
 *
 * Verglichen wird der tatsächliche Offset zu genau diesem Zeitpunkt, nicht der
 * Name der Zeitzone: Wer in Wien sitzt, liest dieselbe Uhrzeit und braucht
 * keinen Hinweis. Der Offset-Vergleich berücksichtigt außerdem, dass die
 * Sommerzeit anderswo zu anderen Terminen umgestellt wird — in der Türkei zum
 * Beispiel gar nicht.
 */
export const localTimeDiffers = (dateTime: DateTime | string): boolean => {
  const local =
    typeof dateTime == "string" ? DateTime.fromISO(dateTime) : dateTime;

  return local.toLocal().offset !== local.setZone(applicationTimeZone).offset;
};
